import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  className?: string;
  title?: string;
  onBack?: () => void;
  children?: any;
}

const MktHeader: FC<IProps> = ({ className, title, onBack, children }: IProps) => {
  return (
    <IonHeader>
      <div className={`mkt-coupon-header ${className || ''}`}>
        {onBack && <div data-cypid='mmgHeaderBack' className='left-back' onClick={onBack}><i className='iconfont icon-BACK-12x'></i></div>}
        {title && <div className='title'>{title || ''}</div>}
        {children}
      </div>
    </IonHeader>
  )
}

export default observer(MktHeader)
